export const REDEMPTION_CODE_REGEX = new RegExp(
  /^(\d{4})(\s|-|)(\d{4})(\s|-|)(\d{4})(\s|-|)(\d{4})$/g,
);

export const PASSWORD_PATTERN_REGEX = new RegExp(
  /^(?=.{8,})(?=.*[A-Z])(?=.*[`~*-/[\]\\|{}().:;,''""!_<>-@#$%^&+=]).*$/,
);
